const initialState = {
    pending: false,
    pendingDelete: false,
    commentsPending: false,
    error: null,
    deleteMessage: '',
    comments: [],
};

const commentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOAD_COMMENTS_PENDING':
            return {
                ...state,
                commentsPending: true
            };
        case 'LOAD_COMMENTS_SUCCESS':
            return {
                ...state,
                commentsPending: false,
                comments: action.payload,
            };
        case 'REFRESH_COMMENTS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'REFRESH_COMMENTS_SUCCESS':
            return {
                ...state,
                pending: false
            };
        case 'REFRESH_COMMENTS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'DELETE_LAST_COMMENT_PENDING':
            return {
                ...state,
                pendingDelete: true
            };
        case 'DELETE_LAST_COMMENT_SUCCESS':
            return {
                ...state,
                pendingDelete: false,
                deleteMessage: action.deleteMessage
            };
        case 'DELETE_LAST_COMMENT_ERROR':
            return {
                ...state,
                pendingDelete: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default commentsReducer;
